import { render, staticRenderFns } from "./testingByShift.vue?vue&type=template&id=27f0c67f&"
import script from "./testingByShift.vue?vue&type=script&lang=js&"
export * from "./testingByShift.vue?vue&type=script&lang=js&"
import style0 from "./testingByShift.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports